import React, { useState, useRef, useEffect } from "react";
import "./ItemSelect.css";

export default function ItemSelect({ value, onChange, items, placeholder = "Select Item" }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selectedItem = value ? items.find(item => item.id === value) : null;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  // Close dropdown when value is reset externally
  useEffect(() => {
    if (!value) {
      setIsOpen(false);
    }
  }, [value]);

  const handleSelect = (itemId) => {
    onChange(itemId);
    setIsOpen(false);
  };

  return (
    <div className={`item-select ${isOpen ? "open" : ""}`} ref={dropdownRef}>
      <button
        type="button"
        className="item-select-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedItem ? (
          <>
            {selectedItem.iconUrl && (
              <img
                src={selectedItem.iconUrl}
                alt={selectedItem.title || selectedItem.name}
                className="item-select-icon"
              />
            )}
            <span className="item-select-text">
              {selectedItem.title || selectedItem.name}
            </span>
          </>
        ) : (
          <span className="item-select-placeholder">{placeholder}</span>
        )}
        <span className="item-select-arrow">▼</span>
      </button>
      {isOpen && (
        <div className="item-select-dropdown">
          {items.length === 0 ? (
            <div className="item-select-option item-select-empty">No items available</div>
          ) : (
            items.map((item) => (
              <button
                key={item.id}
                type="button"
                className={`item-select-option ${value === item.id ? "selected" : ""}`}
                onClick={() => handleSelect(item.id)}
              >
                {item.iconUrl && (
                  <img
                    src={item.iconUrl}
                    alt={item.title || item.name}
                    className="item-select-option-icon"
                  />
                )}
                <span className="item-select-option-text">
                  {item.title || item.name}
                </span>
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}
